import { ThemeIcon } from '@/components/icons/ThemeIcon'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'
import { useDocumentState } from '@/state'
import { useShallow } from 'zustand/react/shallow'
import { useDocumentThemeFlag } from '@/featureFlags/useDocumentThemeFlag'

interface CreateDocumentThemeButtonProps {
  documentPageId?: string
  documentVersionId?: string | null
  isDisabled?: boolean
}

export const CreateDocumentThemeButton = ({
  documentPageId,
  documentVersionId,
  isDisabled,
}: CreateDocumentThemeButtonProps) => {
  const {
    isLoading: isFlagLoading,
    data: { isEnabled },
  } = useDocumentThemeFlag()

  const setDocumentState = useDocumentState(
    useShallow((state) => state.setState),
  )
  const isDocumentTemplatesPreviewEnabled = useDocumentState(
    (state) => state.pageTemplatesEnabled,
  )

  const isButtonDisabled = isDisabled || !documentPageId || !documentVersionId

  if (isFlagLoading || !isEnabled) {
    return null
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="rounded-md hover:bg-gray-100 m-0 h-full flex p-2 items-center justify-center"
            style={{
              backgroundColor: isDocumentTemplatesPreviewEnabled
                ? '#D2E8FF'
                : undefined,
            }}
            onClick={() => {
              setDocumentState({
                pageTemplatesEnabled: !isDocumentTemplatesPreviewEnabled,
                commentsEnabled: false,
              })
            }}
            disabled={isButtonDisabled}
            data-testid="open-document-templates-preview-button"
          >
            <ThemeIcon className="h-[22px] w-[22px]" />
          </Button>
        </TooltipTrigger>
        <TooltipContent className="bg-black text-white">
          <p>Document Templates</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
